import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField, type TextFieldProps } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export type PasswordTextFieldProps = Omit<TextFieldProps, 'type'>;

export const PasswordTextField = React.forwardRef<HTMLDivElement, PasswordTextFieldProps>(
  ({ InputProps, ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <TextField
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        InputProps={{
          ...InputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={visible ? 'Hide password' : 'Show password'}
                onClick={() => setVisible((prev) => !prev)}
                edge="end"
                tabIndex={-1}
              >
                {visible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
              {InputProps?.endAdornment}
            </InputAdornment>
          ),
        }}
      />
    );
  },
);

PasswordTextField.displayName = 'PasswordTextField';

export default PasswordTextField;
